import { useSuspenseQuery } from '@tanstack/react-query';

import { PublicationInfluence } from '@/module/Journal/components/PublicationInfluence';

import { Id } from '@feature/utils';

import { getArticleInfluenceOptions } from '../model/ArticleQuery';

interface ArticleInfluenceProps {
  articleId: Id;
  hideTemporary?: boolean;
}

export function ArticleInfluence({ articleId, hideTemporary }: ArticleInfluenceProps) {
  const { data } = useSuspenseQuery(getArticleInfluenceOptions(articleId));

  return (
    <PublicationInfluence
      hideTemporary={hideTemporary}
      data={data}
    />
  );
}
